export default function Typewriter(root, delay = 0) {
  if (!root) throw new Error("TypewriterError: Cannot find Typewriter's root element");

  const words = root.dataset.typewriter.split(";");
  const writer = document.createElement("span");
  const wordsLength = words.length;
  let isDeleting = false;
  let currentIndex = 0;
  let displayText = "";
  let currentWord;
  let timer;

  writer.textContent = root.textContent;
  root.innerHTML = "";
  root.appendChild(writer);

  function tick() {
    clearTimeout(timer);

    let delta = 200 - Math.random() * 100;
    let textLength = isDeleting ? displayText.length - 1 : displayText.length + 1;

    currentWord = currentIndex % wordsLength;

    displayText = words[currentWord].substring(0, textLength);

    writer.innerHTML = displayText;

    if (isDeleting) {
      delta /= 2;
    }

    if (!isDeleting && displayText === words[currentWord]) {
      delta = 1000;
      isDeleting = true;
    }

    else if (isDeleting && displayText === "") {
      isDeleting = false;
      currentIndex++;
      delta = 500;
    }

    timer = setTimeout(tick, delta);
  }

  timer = setTimeout(tick, delay);

  document.head.appendChild(document.createElement("style")).textContent = `
    [data-typewriter] > span {
      border-right: 0.08em solid;
      padding-right: 0.05em;
      animation: blinkingCaret .8s steps(44) infinite normal;
    }
    @keyframes blinkingCaret {
      from {
        border-right-color: rgba(60,60,60, 1);
      }
      to{
        border-right-color: rgba(60,60,60, 0);
      }
    }
  `;

  return Object.freeze({
    off() {
      if (timer) {
        clearTimeout(timer);
        writer.remove();
      }
    },
    stop() {
      clearTimeout(timer);
    },
    start() {
      timer = setTimeout(tick, delay);
    },
  });
}
